import { AfterViewInit, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDatepicker, MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Device, ProxyStatistic, WebsiteViews } from '../../models';
import { AnalyticService } from '../../services/analytic.service';

@Component({
  selector: 'proxy-statistics-component',
  templateUrl: './proxy-statistics.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ProxyStatisticsComponent {
  /******** Proxy Statistics **********/
  @Input('groupId') public groupId;
  @Input('deviceId') public deviceId;
  @Input('isOnline') public isOnline: boolean;
  @ViewChild('monthPickerPS') public monthPickerPS: MatDatepicker<Date>;
  @ViewChild('startDatePickerPS') public startDatePickerPS: MatDatepicker<Date>;
  @ViewChild('endDatePickerPS') public endDatePickerPS: MatDatepicker<Date>;
  // @ViewChild(MatPaginator) public matpaginator: MatPaginator;
  @ViewChild(MatPaginator)
  set setPaginator(paginator: MatPaginator) {
    if (!this.proxyStatsDataSource) { this.proxyStatsDataSource = new MatTableDataSource<WebsiteViews>(); }
    this.proxyStatsDataSource.paginator = paginator;
  }
  @Input('proxyStats') public proxyStats: ProxyStatistic;
  @Input('proxyStatsLoading') public proxyStatsLoading: boolean;
  public proxyStatsDataSource: MatTableDataSource<WebsiteViews>;
  public sortCols = ['websiteCol', 'viewsCol'];

  public filterDateOpt = 1;
  public websiteFilter: string;
  public monthDate;
  public timeoutSearch;
  public now = Date.now();

  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    private analyticService: AnalyticService,
  ) { }

  public ngOnChanges(changes) {
    if (changes && changes.proxyStats && changes.proxyStats.currentValue) {
      this.proxyStats = changes.proxyStats.currentValue;
      if (!this.proxyStatsDataSource) {
        this.proxyStatsDataSource = new MatTableDataSource(this.proxyStats.viewsList);
      } else {
        this.proxyStatsDataSource.data = this.proxyStats.viewsList;
      }
    }
    // this.getDeviceProxyStatistics();
  }
  /*  public ngAfterViewInit() {
     if (!this.proxyStatsDataSource) {
       this.proxyStatsDataSource = new MatTableDataSource();
     }
     this.proxyStatsDataSource.paginator = this.matpaginator;
     // this.proxyStatsDataSource.sort = this.matsort;
   } */

  public getDeviceProxyStatistics() {
    this.proxyStatsLoading = true;
    this.analyticService.getProxyStatistics(this.getActiveProxyFilters()).subscribe((data) => {
      this.proxyStatsLoading = false;
      if (!data) { return this.proxyStats = null; }
      if (data.viewsList && !data.viewsList.length) {
        if (JSON.stringify(this.getActiveProxyFilters()).length <= 2) {
          this.proxyStats = null;
        } else {
          this.proxyStats.noDataByFilters = true;
        }
        return;
      }
      this.proxyStats = data;
      if (!this.proxyStatsDataSource) {
        this.proxyStatsDataSource = new MatTableDataSource(this.proxyStats.viewsList);
      } else {
        this.proxyStatsDataSource.data = this.proxyStats.viewsList;
      }
    });
  }

  public getActiveProxyFilters() {

    const filters: any = {};
    if (this.groupId) { filters.groupId = this.groupId; }
    if (this.deviceId) { filters.deviceId = this.deviceId; }

    // if (this.deviceFilter) filters.device = this.deviceFilter
    if (this.websiteFilter) { filters.websiteFilter = this.websiteFilter; }
    if (this.filterDateOpt == 2 && this.monthDate) {
      const month = new Date(this.monthDate);
      const firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
      const lastDay = new Date(month.getFullYear(), month.getMonth() + 1);

      filters.startDate = `${firstDay.getFullYear()}/${firstDay.getMonth() + 1}/${firstDay.getDate()} 00:00`;
      filters.endDate = `${lastDay.getFullYear()}/${lastDay.getMonth() + 1}/${lastDay.getDate()} 23:59`;
    } else if (this.filterDateOpt == 3) {
      if (this.startDatePickerPS && this.startDatePickerPS._selected) {
        const startDate = new Date(this.startDatePickerPS._selected);
        filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
      }
      if (this.endDatePickerPS && this.endDatePickerPS._selected) {
        const endDate = new Date(this.endDatePickerPS._selected);
        filters.endDate = `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()} 23:59`;
      }
    }
    return filters;
  }

  public filterProxyStats(websiteName: string) {
    this.proxyStatsDataSource.filter = websiteName.trim().toLowerCase();
    if (this.proxyStatsDataSource.paginator) {
      this.proxyStatsDataSource.paginator.firstPage();
    }
  }
  public sortProxyStats(event: MatSort) {
    const defaultSort = Object.assign([], this.proxyStats.viewsList);
    if (event.direction === '') {
      this.proxyStatsDataSource.data = defaultSort;
      return;
    }
    // cloning required... else, it wont sort
    if (event.active == 'websiteCol') {
      this.proxyStatsDataSource.data = defaultSort.sort((a, b) => {
        const wa = a.website.toLowerCase();
        const wb = b.website.toLowerCase();
        let r = 0;
        if (wa < wb) { r = -1; } else
          if (wa > wb) { r = 1; }
        return event.direction == 'asc' ? r : -r;
      });
    } else if (event.active == 'viewsCol') {
      this.proxyStatsDataSource.data = defaultSort.sort((a, b) => {
        let r = 0;
        if (a.views < b.views) { r = -1; } else
          if (a.views > b.views) { r = 1; }
        return event.direction == 'asc' ? r : -r;
      });
    }
  }

  // analytics functions
  public search(event) {
    if (!this.websiteFilter || (event && event.keyCode == 13)) {
      clearTimeout(this.timeoutSearch);
      this.getDeviceProxyStatistics();
      return;
    }

    if (this.timeoutSearch) {
      clearTimeout(this.timeoutSearch);
    }
    this.timeoutSearch = setTimeout(() => {
      this.getDeviceProxyStatistics();
    }, 1000);
  }
  public onDateChange() {
    try {
      const start = this.startDatePickerPS._selected.getTime();
      const end = this.endDatePickerPS._selected.getTime();
      if (start && end && start <= end) {
        this.getDeviceProxyStatistics();
      } else {
        this.toastr.error('End date is before start date.');
      }
    } catch (error) {
      if (!this.startDatePickerPS._selected) { this.startDatePickerPS.open(); } else if (!this.endDatePickerPS._selected) { this.endDatePickerPS.open(); } else { this.toastr.error(error, 'Error reading dates.'); }
    }
  }

  public filterDateOptChange() {
    if (this.filterDateOpt == 1) { this.getDeviceProxyStatistics(); }
    if (this.filterDateOpt == 2) { this.monthPickerPS.open(); }
    if (this.filterDateOpt == 3) { this.startDatePickerPS.open(); }
  }
  public chosenMonthHandler(normalizedMonth) {
    this.monthDate = normalizedMonth;
    this.monthPickerPS.close();
    this.getDeviceProxyStatistics();
  }

  /* public pageChange(page?: PageEvent) {
    if (page) { this.mostViewedPage = page; }
    const paged = this.stat.content.slice(this.mostViewedPage.pageIndex * this.mostViewedPage.pageSize, (this.mostViewedPage.pageIndex + 1) * this.mostViewedPage.pageSize);
    this.mostViewedChart.labels = paged.map((s) => s.name);
    this.mostViewedChart.data = paged.map((s) => s.clicks);
  } */

  public getActiveFilters() {
    const filters: any = { groupId: this.groupId };
    // if (this.deviceFilter) filters.device = this.deviceFilter
    if (this.websiteFilter) { filters.contentFilter = this.websiteFilter; }

    if (this.filterDateOpt == 2 && this.monthDate) {
      const month = new Date(this.monthDate);
      var firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
      var lastDay = new Date(month.getFullYear(), month.getMonth() + 1);

      filters.startDate = `${firstDay.getFullYear()}/${firstDay.getMonth() + 1}/${firstDay.getDate()} 00:00`;
      filters.endDate = `${lastDay.getFullYear()}/${lastDay.getMonth() + 1}/${lastDay.getDate()} 23:59`;
    } else if (this.filterDateOpt == 3) {
      if (this.startDatePickerPS && this.startDatePickerPS._selected) {
        const startDate = new Date(this.startDatePickerPS._selected);
        filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
      }
      if (this.endDatePickerPS && this.endDatePickerPS._selected) {
        const endDate = new Date(this.endDatePickerPS._selected);
        filters.endDate = `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()} 23:59`;
      }
    }
    return filters;
  }

}
